import * as constants from './constants'

export const getOnstreetLocations = () => ({
    type: constants.GET_ONSTREET_LOCATIONS,
})

export const setOnstreetLocations = locations => ({
    type: constants.SET_ONSTREET_LOCATIONS,
    locations,
})
